// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';

import { CollapsePanel } from 'Components/frameworks/collapse-panel/CollapsePanel';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';

export type Service = {
  label: string,
  icon: string,
  description?: string,
};

export type Props = {
  service: Service,
  className?: string,
};

export const ProductService = ({ service, className = '' }: Props): Node => {
  const { description, icon, label } = service;

  return description ? (
    <CollapsePanel
      className={className}
      collapseIconName={ICONS.BOLDER_ARROW_FORTH_DOWN}
      collapseLabel={t('common.included')}
      expandIconName={ICONS.BOLDER_ARROW_FORTH_DOWN}
      expandLabel={t('common.included')}
      hasEllipsis={false}
      hasKeepCollapsedContent={false}
      iconName={icon}
      id={icon}
      isExpanded={false}
      key={icon}
      theme="remote"
      title={label}
    >
      <p className="reset-paragraph mb-5 text-base">{description}</p>
    </CollapsePanel>
  ) : (
    <section
      className={classnames(className, 'fadeIn border-b-1 flex items-center py-5 text-base')}
    >
      <span className="flex items-center flex-1 max-w-full overflow-hidden text-gray-darker">
        <Icon
          className="rtl:mr-4 flex-shrink-0"
          color={COLORS.BLUE}
          name={icon}
          width="1.375rem"
        />
        {label}
      </span>
      <span className="flex-shrink-0 font-bold rtl:ml-auto text-blue">{t('common.included')}</span>
    </section>
  );
};
